<span cobaltModalTitle aria-label="No Internet Connection"
  >Session expired</span
>

<div cobaltModalContent>
  You have been automaticaly logged out due to security reasons. If you believe
  there is an error, please contact support with a screenshot. Thank you.
</div>

<div cobaltModalActions>
  <button
    (click)="loginClick()"
    [tabIndex]="1"
    cobaltButtonPrimary
    aria-label="LOG IN"
  >
    Log In
  </button>
</div>
